import { Component, Inject, OnInit } from '@angular/core';
import { BZG_MODAL_DATA, BzgModalRef } from 'bz-genome-angular';

@Component({
  selector: 'download-certificate-password-modal',
  templateUrl: './download-certificate-password-modal.component.html',
  styleUrls: ['./download-certificate-password-modal.component.scss']
})
export class DownloadCertificatePasswordModalComponent implements OnInit {
  public password: string = '';
  public showPassword: boolean = false;

  constructor(
    public modalComponentRef: BzgModalRef,
    @Inject(BZG_MODAL_DATA) public data: {
      title: string,
      message: string,
      button: string,
      cancelButton?: string,
      passwordPlaceholder?: string
    }
  ) { }

  ngOnInit(): void {
    this.password = '';
  }

  close() {
    this.modalComponentRef.close();
  }

  confirm() {
    this.modalComponentRef.close({ password: this.password });
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  get passwordInputType() {
    return this.showPassword ? 'text' : 'password';
  }

  get isActionDisabled() {
    return !this.password || this.password.trim().length === 0;
  }
}
